export enum DCUICaptureStepTypes {
    FACE = "face",
    DRIVER_LICENSE_FRONT = 'dlfront',
    DRIVER_LICENSE_BACK = 'dlback',
    PASSPORT = 'passport',
    ID_CARD_FRONT = 'idfront',
    ID_CARD_BACK = 'idback',
    LIVENESS_CHECK = 'face3d',
    LIVENESS_CHECK_AUDIT_TRAIL_IMAGE = 'atimage',
    LIVENESS_CHECK_LOW_QUALITY_AUDIT_TRAIL_IMAGE = 'lqatimage',
    NONE = "none"
}